module.exports = __webpack_public_path__ + "img/icvNum1.4abb84ab.png";